<template>
  <div id="app-inner">
    <select-lang v-if="langSelect"></select-lang>

    <score-board></score-board>
    <starting-menu-modal :lang="lang" v-if="modalIsOpen" :modal-is-open="modalIsOpen" @close="modalIsOpen = !modalIsOpen"></starting-menu-modal>

    <change-rounds :round="round" :timeToChangeRound="timeToChangeRound" :lang="lang"></change-rounds>
    <score-board></score-board>
    
    <learning-module :volume="volume" :lang="lang" v-if="module.modules[0].isOpen == true" name="0"></learning-module>
    <learning-module :volume="volume" :lang="lang" v-if="module.modules[1].isOpen == true" name="1"></learning-module>
    <learning-module :volume="volume" :lang="lang" v-if="module.modules[2].isOpen == true" name="2"></learning-module>
    <learning-module :volume="volume" :lang="lang" v-if="module.modules[3].isOpen == true" name="3"></learning-module>
    <learning-module :volume="volume" :lang="lang" v-if="module.modules[5].isOpen == true" name="5"></learning-module>
    <learning-module :volume="volume" :lang="lang" v-if="module.modules[4].isOpen == true" name="4"></learning-module>

    <div class="col col-1">
      <gaming-place
        class="card" 
        @roundChange="handleRoundChange" 
        @levelChange="handleLevelChange" 
        @lastGameScore="handleLastGameScore"
        @highestGameScore="handleHighestGameScore"
        @formatTime="handleFormatTime"
        @scoreChange="handleScoreChange"
        :timeToChangeRound="timeToChangeRound"
        :lang="lang"
      ></gaming-place>
    </div>

    <div class="col col-2">
      <game-overview
        class="card grey"
        :round="round"
        :level="level"
        :lastGameScore="lastGameScore"
        :highestGameScore="highestGameScore"
        :formatTime="formatTime"
        :score="score"
        :name="name"
        :lang="lang"
      ></game-overview>
      <learning-modules :lang="lang" :progress="progress" class="card grey"></learning-modules>
      <game-footer class="card grey"></game-footer>
    </div>
  </div>
</template>

<script>

import GamingPlace from './components/GamingPlace.vue';
import GameOverview from './components/GameOverview.vue';
import LearningModules from './components/LearningModules.vue';
import GameFooter from './components/GameFooter.vue';
import ChangeRounds from './components/ChangeRounds.vue';
import modulesData from "./assets/modules.json";
import configLang from "./assets/config.json";
import ScoreBoard from "./components/ScoreBoard.vue";
import SelectLang from "./components/SelectLang.vue";

export default {
  name: 'App',
  components: {
    GamingPlace,
    GameOverview,
    LearningModules,
    GameFooter,
    ChangeRounds,
    ScoreBoard,
    SelectLang
  },
  data() {
    return {
      timeToChangeRound: 2500,
      round: 1,
      progress: 0,
      level: 1,
      lang: "en",
      langConfig: configLang,
      modalIsOpen: false,
      module: modulesData,
      volume: 50,
      name: null,
      langSelect: true
    }
  },
  methods: {
    handleRoundChange(newRound){
      this.round = newRound;
    },
    handleLevelChange(newLevel){
      this.level = newLevel;
    },
    handleLastGameScore(newLastGameScore){
      this.lastGameScore = newLastGameScore;
    },
    handleHighestGameScore(newHighestGameScore){
      this.highestGameScore = newHighestGameScore;
    },
    handleFormatTime(newFormatTime){
      this.formatTime = newFormatTime;
    },
    handleScoreChange(newScore){
      this.score = newScore;
    },
  }
}

</script>

<style lang="scss">

#app{
  background: url("@/assets/img/gaming_background.png");
  font-family: 'Open Sans', sans-serif;
  background-size: cover;
  background-repeat: repeat-x;
  min-height: 100vh;
}

#app-inner{
  padding: 40px 20px;
  min-height: 100vh;
  max-width: 1440px;
  margin: auto;

  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 50px;
}

.col{
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: 50px;
}

.col-1{
  width: 100%;
  height: 60vh;
}

.card{
  background: white;
  padding: 35px 35px;
  border-radius: 30px;
  
  height: 100%;

  position: relative;
}

.grey {
  background-color: #EFEFEF !important;
}

@media only screen and (max-width: 1000px){
  #app-inner{
    flex-direction: column;
    padding: 20px 20px;

    gap: 25px;

    .col-1{
      height: 40vh;
    }
  }
}

@media only screen and (max-width: 800px){
  .card{
    padding: 20px 20px;
  }

  .col-2{
    gap: 25px;
  }
}

</style>
